/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AwardPayloadModel model module.
 * @module model/AwardPayloadModel
 * @version v1.0.0
 */
class AwardPayloadModel {
    /**
     * Constructs a new <code>AwardPayloadModel</code>.
     * @alias module:model/AwardPayloadModel
     * @param name {String} 獲獎名 [required]
     * @param seq {Number} seq [required]
     * @param yearOf {String} YearOf [required]
     */
    constructor(name, seq, yearOf) { 
        
        AwardPayloadModel.initialize(this, name, seq, yearOf);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, seq, yearOf) { 
        obj['name'] = name;
        obj['seq'] = seq;
        obj['yearOf'] = yearOf;
    }

    /**
     * Constructs a <code>AwardPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AwardPayloadModel} obj Optional instance to populate.
     * @return {module:model/AwardPayloadModel} The populated <code>AwardPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AwardPayloadModel();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
            if (data.hasOwnProperty('yearOf')) {
                obj['yearOf'] = ApiClient.convertToType(data['yearOf'], 'String');
            }
        }
        return obj;
    }


}

/**
 * 獲獎名 [required]
 * @member {String} name
 */
AwardPayloadModel.prototype['name'] = undefined;

/**
 * seq [required]
 * @member {Number} seq
 */
AwardPayloadModel.prototype['seq'] = undefined;

/**
 * YearOf [required]
 * @member {String} yearOf
 */
AwardPayloadModel.prototype['yearOf'] = undefined;






export default AwardPayloadModel;

